import { AccountingLayout as _AccountingLayout } from "@/components/layouts/accounting-layout";
import { Outlet, createFileRoute, useMatches } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$company/buchhaltung")({
  component: AccountingLayout,
});

function AccountingLayout() {
  const matches = useMatches();
  const currentRoute = matches[matches.length - 1];

  // Convention: pathless routes starting with '_' handle their own layout
  // e.g., _focused, _fullscreen, _settings, etc.
  const hasCustomLayout = matches.some((match) =>
    match.routeId.includes("/buchhaltung/_"),
  );

  if (hasCustomLayout) {
    return <Outlet />;
  }

  const location =
    (currentRoute?.staticData as { breadcrumb?: string[] })?.breadcrumb ?? [];

  return (
    <_AccountingLayout location={location}>
      <div className="flex-1">
        <Outlet />
      </div>
    </_AccountingLayout>
  );
}
